/** Headings and dark UI surfaces */
export const BRAND_PRIMARY = "#161616";

/** Full-page and inline loaders */
export const LOADER_TRACK_COLOR = "#e5e7eb";
export const LOADER_SPIN_CLASS = "loader-spin";
export const LOADER_SPIN_ON_DARK_CLASS = "loader-spin loader-spin--on-dark";
export const BRAND_PRIMARY_HOVER = "#2a2a2a";
export const BRAND_PRIMARY_LIGHT = "#f5f5f5";

/** Links, buttons, focus borders — sidebar nav (light) / hover (dark header) */
export const BRAND_ACCENT = "#BA2E5D";
export const BRAND_ACCENT_HOVER = "#9A1844";
export const BRAND_ACCENT_LIGHT = "#fdf2f6";

/** Default text input / select height (auth + portal forms) */
export const FORM_CONTROL_HEIGHT = "48px";

/** Default field padding — matches auth `InputField` large */
export const FORM_CONTROL_PADDING = "10px 16px";

/** Default field corner radius — matches auth screens */
export const FORM_CONTROL_BORDER_RADIUS = "10px";

/** Default / hover field border (Figma Gray/300) */
export const FORM_CONTROL_BORDER = "#D0D5DD";

/** Form field labels — fixed 1rem (not rem-scaled by root 80%) */
export const FORM_LABEL_FONT_SIZE = "1rem";

/** Form field value and placeholder text */
export const FORM_INPUT_FONT_SIZE = "13px";

/** Tailwind label classes for InputField / Select */
export const FORM_FIELD_LABEL_CLASS = "mb-2 block text-[1rem] font-semibold text-[#2f2f2f]";

export const FORM_FIELD_LABEL_CLASS_AUTH = "mb-3 block text-[1rem] font-semibold text-[#2f2f2f]";
